import React, {useContext} from "react";
import './Expo.scss';
import Utils from 'utils/Utils';
import { SettingsContext } from 'Providers/SettingsProvider';
import {
  useNavigate,
} from "react-router-dom";
import shim from 'string.prototype.matchall/shim';
shim();

function Expo({expo,toggle=true}) {
  const { t, filter, setFilter, translate } = useContext(SettingsContext);
  const { search, ...otherFilter } = filter;
  const navigate = useNavigate();
  //expo
  const expoRegex=/\+([^\s]+)/g;
  const expoRes=Utils.accentsTidyLw(search).matchAll(expoRegex) || [];
  const expos=[...expoRes].map((t)=>t[1]);
  const active=expos.reduce((acc,t)=>{
      return acc || Utils.accentsTidyLw(t.replace(/\s/g,'_'))===Utils.accentsTidyLw(expo.title.replace(/\s/g,'_'));
  },false);
  const toggleExpo=()=>{
      const escapedExpo=Utils.accentsTidyLw(expo.title.replace(/\s/g,'_'));
      if (!active) {
          setFilter({search:(" +"+escapedExpo).trim(), ...otherFilter});
          if (window.location.pathname!=='/') {
            navigate("/");
          }
      } else {
          if (toggle) setFilter({search:search.replace("+"+escapedExpo,'').trim()});
      }
  };
  let classes="expo";
  if (active) classes+=" active";
  const Picto=Utils.pictos.groupe;
  return <div className="menu-left-item-expo">
      <div className="item-type">{t('expositions-en-ligne')}</div>
      <div className={classes}>
        <span className='expo-span' onClick={toggleExpo}>{translate(expo,'title')}</span>
        <div className="picto carre" onClick={toggleExpo}><Picto/></div>
        <div className="infos"><a href={`https://www.centredartlelait.com/expos/${expo.slugs && expo.slugs[0] && expo.slugs[0].slug}`} target="_blank" rel="noreferrer">+</a></div>
      </div>
  </div>
  ;
}

export default Expo;
